import { render, staticRenderFns } from "./3c_doc.vue?vue&type=template&id=dcbcbc9e&scoped=true"
import script from "./3c_doc.vue?vue&type=script&lang=js"
export * from "./3c_doc.vue?vue&type=script&lang=js"
import style0 from "./3c_doc.vue?vue&type=style&index=0&id=dcbcbc9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbcbc9e",
  null
  
)

export default component.exports